export enum ActionTypes {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  GET_VIOLENCE_TYPES = 'GET_VIOLENCE_TYPES',
  SET_NOTIFICATION_CODE = 'SET_NOTIFICATION_CODE',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
  TO_MANY_USER_LOGIN_ATTEMPTS = 'TO_MANY_USER_LOGIN_ATTEMPTS',
}
